<template>
  <div>
    <div class="remark" @mouseover="open = true" @mouseout="open = false">{{remark}}</div>
    <fm-poper :value="open" position="right-end">
      <div class="long-remark">
        {{remark}}
      </div>
    </fm-poper>
  </div>
</template>

<script>
export default {
  data () {
    return {
      open: false
    }
  },
  methods: {
    copen () {
      this.open = !this.open
    }
  },
  props: {
    remark: {
      type: String
    }
  }
}
</script>

<style lang="less" scoped>
.long-remark {
  max-width: 300px;
  border-radius: 10px;
  border: 1px solid #ccc;
  background: #fff;
  padding: 10px 15px;
}
.remark {
  overflow: hidden;
  max-width: 400px;
  text-overflow:ellipsis;
  white-space:nowrap;
}
</style>